import { render } from "./ColorSwatch.vue?vue&type=template&id=0981804d"
import script from "./ColorSwatch.vue?vue&type=script&lang=js"
export * from "./ColorSwatch.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "0981804d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0981804d', script)) {
    api.reload('0981804d', script)
  }
  
  module.hot.accept("./ColorSwatch.vue?vue&type=template&id=0981804d", () => {
    api.rerender('0981804d', render)
  })

}

script.__file = "src/icons/components/filled/ColorSwatch.vue"

export default script